import PhotoSwipeLightbox from "photoswipe/lightbox";
import 'photoswipe/style.css';

window.pswpLightbox = [];
const pswpdebug = false;

function getImageData( wrapper, index ) {

    var img = wrapper.querySelector('img');
    var file = wrapper.getAttribute('href');
    var width = wrapper.getAttribute('data-pswp-width');
    var height = wrapper.getAttribute('data-pswp-height');

    if (pswpdebug) console.log('PhotoSwipeLightbox: getImageData( ' + index + ' )', wrapper, img, file, width, height);

    return {
        id: index,
        src: file,
        width: width,
        height: height
    };
}


function initLightbox( lb_id = 0, images = [], galleryEl = document.querySelector('#event-detail-gallery')) {
    if (pswpdebug) console.log('PhotoSwipeLightbox: initLightbox( ' + lb_id + ' )');

    const lightbox = new PhotoSwipeLightbox({
        dataSource: images,
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 1.5,
        maxZoomLevel: 4,

        // padding: { top: 16, bottom: 16, left: 20, right: 20 },

        paddingFn: (viewportSize, itemData, index) => {
            if (viewportSize.x < 600) {
                return {
                    top: 16,
                    right: 20,
                    bottom: 16,
                    left: 20
                };
            }

            return {
                top: 50,
                right: 50,
                bottom: 50,
                left: 50
            };

            // return {
            //     // check based on slide index
            //     top: index === 0 ? 100 : 0,
            //
            //     // check based on viewport size
            //     bottom: viewportSize.x < 600 ? 0 : 200,
            //
            //     // check based on image size
            //     left: itemData.w < 2000 ? 50 : 0,
            //
            //     right: 0
            // };
        },

        pswpModule: () => import('photoswipe'),
    });

    if (pswpdebug) console.log( 'PhotoSwipeLightbox: initLightbox> lightbox = ', lightbox)

    // set all to cropped
    lightbox.addFilter('itemData', (itemData, index) => {
        itemData.thumbCropped = true;
        return itemData;
    });

    // set thumbnail to elements img
    lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
        const el = galleryEl.querySelector('[data-thumbid="' + lb_id + '_' + data.id + '"] img');
        if (el) {
            return el;
        }
        return thumbEl;
    });

    // set placeholder src to elements img src
    lightbox.addFilter('placeholderSrc', (placeholderSrc, slide) => {
        const el = galleryEl.querySelector('[data-thumbid="' + lb_id + '_' + slide.data.id + '"] img');
        if (el) {
            return el.src;
        }
        return placeholderSrc;
    });
    lightbox.init();

    // expose to use within onclick attribute

    window.pswpLightbox[ lb_id ] = lightbox;

}

function initGallery(
    gallery_selector = '#event-detail-gallery',
    hero_selector = '.kn-se-hero',
    image_selector = '.kn-sevent-thumbs .kn-sevent-thumb') {

    // todo: make work with multiple galleries in one page

    if (pswpdebug) console.log('PhotoSwipeLightbox: initGallery("' + gallery_selector + '", "' + hero_selector + '", "' + image_selector + '")');

    const gallery_elements = document.querySelectorAll( gallery_selector );
    const hero_ele = hero_selector != '' ? document.querySelector( hero_selector ) : false;

    // only works with gallery
    if (!gallery_elements) return;

    var images = [];

    if ( hero_selector != '' && hero_ele) {
        images.push(getImageData(hero_ele, 1));
    }

    if (gallery_elements.length > 0) {

        gallery_elements.forEach(function(gallery_ele, index) {

            if (pswpdebug) console.log('PhotoSwipeLightbox: initGallery > gallery_element ', gallery_ele);

            // reset images after first run
            if (index !== 0) {
                images = [];
            }

            var gallery_image_elements = gallery_ele.querySelectorAll( image_selector );
            gallery_image_elements.forEach(function(img, index) {
                images.push( getImageData( img, index + 2 ) );
            })

            if (pswpdebug) console.log('PhotoSwipeLightbox: initGallery > images ', images);

            initLightbox( index, images, gallery_ele );

        });

    } else {
        if (pswpdebug) console.log('PhotoSwipeLightbox: initGallery > no galleries found with selector: ', gallery_selector);
    }

    if (pswpdebug) console.log('PhotoSwipeLightbox: initLightbox> done');

}

setTimeout(() => {

    // event detail gallery
    initGallery();

    // default page galleries
    initGallery('#kn-gallery-container .pswp-gallery', '');

}, 100);

export default 'photoswipe';


